import React, { useMemo } from 'react';

import useLoadPeriodos from '../../hooks/useLoadPeriodos';
import { getEdicao } from '../../helper/ContextHelper';

import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import Header from '../../components/Header/Header';
import { Download } from '../../components/Download/Download';
import Title from '../../components/Title/Title';

import Navbar from './NavbarRegulamento';
import Preliminares from './Preliminares';
import Participantes from './Participantes';
import Inscricao from './Inscricao';
import Cronograma from './Cronograma';
import Estrutura from './Estrutura';
import AplicacaoProva from './AplicacaoProva';
import ObrigacoesProfessor from './ObrigacoesProfessor';
import ObrigacoesIMPA from './ObrigacoesIMPA';
import Premiacao from './Premiacao';
import DisposicoesFinais from './DisposicoesFinais';
import Anexo1 from './Anexo1';
import Anexo2 from './Anexo2';
import Anexo3 from './Anexo3';

import pdfRegulamento from '../../assets/docs/regulamento.pdf';

import useStyles from './Style';

import Layout from '../../layouts/public/Public';

const Regulamento = () => {
    const classes = useStyles();

    const contexts = useLoadPeriodos();

    const edicao = useMemo(() => contexts ? getEdicao(contexts) : "-", [ contexts ]);
    
    return (
        <Layout title="Regulamento">
            <Header />
            
            <Container maxWidth="xl" className={classes.container} >                
                <Grid container spacing={6} >
                    <Grid item xs={12} sm={12} lg={3} xl={3} >
                        <Navbar edicao={edicao} />
                    </Grid>

                    <Grid item xs={12} sm={12} lg={9} xl={9} >                        
                        <Title variant="h4">
                            REGULAMENTO DA {edicao}ª OLIMPÍADA DE PROFESSORES DA OBMEP MIRIM
                        </Title>
                        <Typography className={classes.textInitial} variant="body2">
                            A Associação Instituto Nacional de Matemática Pura e Aplicada (<span className={classes.bolder}>IMPA</span>), associação privada sem fins lucrativos qualificada como organização social pelo Decreto 3.605/00, 
                            vinculada ao Ministério da Ciência, Tecnologia e Inovação (MCTI) e ao Ministério da Educação (MEC), vem, por meio deste instrumento, tornar pública a realização da {edicao}ª Olimpíada de 
                            Professores da OBMEP Mirim, mediante as condições estabelecidas neste Regulamento.
                        </Typography>

                        <Preliminares edicao={edicao} />
                        <Participantes edicao={edicao} />
                        <Inscricao edicao={edicao} />
                        <Cronograma />
                        <Estrutura edicao={edicao} />
                        <AplicacaoProva edicao={edicao} />
                        <Premiacao />
                        <ObrigacoesProfessor edicao={edicao} />
                        <ObrigacoesIMPA edicao={edicao} />
                        <DisposicoesFinais edicao={edicao} />
                        <Anexo1 edicao={edicao} />
                        <Anexo2 edicao={edicao} />
                        <Anexo3 />
                    </Grid>
                </Grid>
            </Container>
            
            <Download type="Regulamento" file={pdfRegulamento} />
        </Layout>
    )
}

export default Regulamento;